import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrPutDepartmentInput, Department } from '@thro-types/billing';

import { AxiosRequestConfig } from 'axios';

import {
  createDepartment,
  getDepartments,
  getDepartmentsWithInvoices,
  updateDepartment,
  UpdateInterface
} from 'api/billingService';

export const useGetDepartmentsQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['department', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getDepartments(config);
    },
    placeholderData: keepPreviousData
  });
};

export const useGetDepartmentsWithInvoicesQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['department', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getDepartmentsWithInvoices(config);
    },
    placeholderData: keepPreviousData
  });
};

export const useDepartmentMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['department'];
  const creation = useMutation<Department, Error, CreateOrPutDepartmentInput>({
    mutationFn: async args => {
      return await createDepartment(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<Department, Error, UpdateInterface<CreateOrPutDepartmentInput>>({
    mutationFn: async args => {
      return await updateDepartment(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { creation, update } as const;
};
